import type { ChangelogEntry } from "../types";

/** VIB-2869: dra og slipp filer på Dokumenter-fanen, flere om gangen. */
export const DOKUMENTER_DRA_OG_SLIPP_2026_10: ChangelogEntry = {
  id: "2026-10-12-dokumenter-dra-og-slipp",
  date: "2026-10-12",
  title: "Dra filer rett inn på Dokumenter-fanen",
  summary:
    "Opplastingssonen på et prosjekts Dokumenter-fane tar nå imot filer du drar inn, og du kan laste opp flere om gangen.",
  sections: [
    {
      heading: "Inne på et prosjekt",
      minRole: "user",
      items: [
        {
          title: "Dra og slipp filer",
          kind: "nytt",
          body: "Dra én eller flere filer fra Finder eller Utforsker og slipp dem i «Last opp dokument»-sonen. Sonen lyser opp når du holder filene over den, og dokumentene dukker opp i listen når de er lastet opp.",
        },
        {
          title: "Flere filer om gangen",
          kind: "forbedret",
          body: "Klikker du på sonen, kan du velge flere filer i filvelgeren. Sonen viser «Laster opp 2 av 5» underveis, og du får én beskjed når alt er oppe i stedet for én per fil.",
        },
      ],
    },
  ],
};
